// Module
var code = "<div>\n    {{$state.current.displayTab || $state.current.display}}\n</div>\n";
// Exports
module.exports = code;